import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'dmmp-h1',
  templateUrl: './h1.component.html',
})
export class H1Component implements OnInit {
  @Input() data
  @Input() identifier
  @Input() layout
  @Input() arrayTypesLabels: Array<any> = ['programs', 'event', 'news', 'blog', 'campus'];
  text: string;

  ngOnInit(): void {

    const hasTitle = this.layout.identifier !== null && this.arrayTypesLabels.some(type => type === this.layout.identifier);

    if (this.data.h1_filter === true) {
      this.text = this.data.name ? this.data.name : ''
    } else {
      if (this.layout !== undefined) {
        this.text =
          this.layout.identifier === 'event' && hasTitle ?
            this.layout.name : this.layout.title
      } else {
        this.text = this.text !== null ? this.text : ''
      }
    }
  }
}
